/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceTeamMemberRequest } from './ServiceTeamMemberRequest';
import {
	ServiceTeamMemberRequestFromJSON,
	ServiceTeamMemberRequestFromJSONTyped,
	ServiceTeamMemberRequestToJSON,
} from './ServiceTeamMemberRequest';

/**
 * Payload to create a service team
 * @export
 * @interface CreateServiceTeamRequest
 */
export interface CreateServiceTeamRequest {
	/**
	 * The name of the service team
	 * @type {string}
	 * @memberof CreateServiceTeamRequest
	 */
	name: string;
	/**
	 * The description of the service team
	 * @type {string}
	 * @memberof CreateServiceTeamRequest
	 */
	description?: string;
	/**
	 *
	 * @type {Array<ServiceTeamMemberRequest>}
	 * @memberof CreateServiceTeamRequest
	 */
	members?: Array<ServiceTeamMemberRequest>;
}

/**
 * Check if a given object implements the CreateServiceTeamRequest interface.
 */
export function instanceOfCreateServiceTeamRequest(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'name' in value;

	return isInstance;
}

export function CreateServiceTeamRequestFromJSON(json: any): CreateServiceTeamRequest {
	return CreateServiceTeamRequestFromJSONTyped(json, false);
}

export function CreateServiceTeamRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateServiceTeamRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		name: json['name'],
		description: !exists(json, 'description') ? undefined : json['description'],
		members: !exists(json, 'members')
			? undefined
			: (json['members'] as Array<any>).map(ServiceTeamMemberRequestFromJSON),
	};
}

export function CreateServiceTeamRequestToJSON(
	value?: CreateServiceTeamRequest | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		name: value.name,
		description: value.description,
		members:
			value.members === undefined
				? undefined
				: (value.members as Array<any>).map(ServiceTeamMemberRequestToJSON),
	};
}
